// src/lib/notifications.js
import { getToken, onMessage } from "firebase/messaging";
import { getMessagingInstance } from "./firebase";
import { saveFcmToken } from "./db";

// From Firebase Console → Project Settings → Cloud Messaging → Web Push certificates
export const VAPID_KEY = "BCORAthS45c1c-Ltns5Asu_Uv1iHQ-YjdGsSB0YJGGSp58WlpF_oK1ay0wPpFLbrmYEp2daLvmUu3dbtnYOfkZI";

export async function requestNotificationPermission(uid) {
  try {
    const messaging = await getMessagingInstance();
    if (!messaging) return null;
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token) await saveFcmToken(uid, token);
    return token;
  } catch (err) {
    console.error("FCM token error:", err);
    return null;
  }
}

export async function onForegroundMessage(callback) {
  const messaging = await getMessagingInstance();
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}

// Reminder thresholds in days (used by Cloud Function)
export const REMINDER_DAYS = [30, 7, 1, 0];
